import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';

import { queryClient } from '@/lib/query-client';

import type { ReactNode } from 'react';

interface ProvidersProps {
  readonly children: ReactNode;
}

// Devtools (React Query + TanStack Router) viven en __root.tsx detrás del
// atajo ⌘+Shift+D. Acá no las montamos para no contaminar la UI con un
// botón flotante permanente.
export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <Toaster
        position="bottom-right"
        theme="system"
        richColors
        closeButton
        toastOptions={{
          style: { borderRadius: 'var(--radius-md)' },
        }}
      />
    </QueryClientProvider>
  );
}
